<template>
	<figure
		:class="{ 'service-cover' :  type === 'service'}">
		<svg 
			v-if="animal === 'bird'" 
			viewBox="0 0 598 667" 
			xmlns="http://www.w3.org/2000/svg">
				
			<BirdVector
				:fill="fill" />

		</svg>

		<svg 
			v-else-if="animal === 'cock'" 
			viewBox="0 0 380 530" 
			xmlns="http://www.w3.org/2000/svg" 
			id="origami-cock">
			<defs>
				<polygon id="path-1" points="0 12.6379015 56.832062 30.8154091 45.4975413 0.00375757576"></polygon>
				<linearGradient x1="0%" y1="50.0003647%" x2="99.9999631%" y2="50.0003647%" id="linearGradient-3">
						<stop stop-color="#F6E275" offset="0%"></stop>
						<stop stop-color="#E2BA5B" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-4" points="32.8295 10.3089637 28.8489348 44.7701036 0.216173913 0.108419689"></polygon>
				<linearGradient x1="0.000144959416%" y1="50.0001285%" x2="99.9999403%" y2="50.0001285%" id="linearGradient-6">
						<stop stop-color="#CD6457" offset="0%"></stop>
						<stop stop-color="#B3524D" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-7" points="0.0409315068 30.767145 17.9787945 0.0719389313 16.3284658 16.851458"></polygon>
				<linearGradient x1="-0.000838511024%" y1="50.0001205%" x2="99.9992994%" y2="50.0001205%" id="linearGradient-9">
						<stop stop-color="#CD6457" offset="0%"></stop>
						<stop stop-color="#B3524D" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-10" points="8.25755502 0.0495604651 54.4258708 32.406907 97.9971866 100.801288 0.150282297 79.393986 4.05293301 44.6781721"></polygon>
				<linearGradient x1="-0.000144699734%" y1="50.0000842%" x2="100.000005%" y2="50.0000842%" id="linearGradient-12">
						<stop stop-color="#FFFFFF" offset="0%"></stop>
						<stop stop-color="#EFF0F0" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-13" points="1.58790431 24.1822452 47.9970144 0.222716129 45.2768612 73.9928387 0.0507559809 41.1084323"></polygon>
				<linearGradient x1="-0.000142216644%" y1="50.0000518%" x2="100.000014%" y2="50.0000518%" id="linearGradient-15">
						<stop stop-color="#CD6457" offset="0%"></stop>
						<stop stop-color="#B3524D" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-16" points="1.50228824 18.7843682 40.7609941 0.185573222 0.0344882353 55.9929707"></polygon>
				<linearGradient x1="0.000129688629%" y1="50.0000435%" x2="100.000074%" y2="50.0000435%" id="linearGradient-18">
						<stop stop-color="#CD6457" offset="0%"></stop>
						<stop stop-color="#B3524D" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-19" points="0.0339625 18.2853659 12.5112625 0.212195122 56.876025 0.247804878 31.23125 25.727561 7.3043125 29.9836585"></polygon>
				<linearGradient x1="9.1503541e-05%" y1="50.0001912%" x2="99.999801%" y2="50.0001912%" id="linearGradient-21">
						<stop stop-color="#CD6457" offset="0%"></stop>
						<stop stop-color="#B3524D" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-22" points="0.153194969 0.00333796296 113.970604 102.798053 99.8965031 21.7334769"></polygon>
				<linearGradient x1="47.6325679%" y1="52.1331408%" x2="81.8811121%" y2="21.2748963%" id="linearGradient-24">
						<stop stop-color="#FBFDFD" offset="0%"></stop>
						<stop stop-color="#E6E6E8" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-25" points="23.1591913 0.00330131004 0.0169043478 141.371528 44.310287 161.987031 134.971122 101.669266"></polygon>
				<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-27">
						<stop stop-color="#F4F5F6" offset="0%"></stop>
						<stop stop-color="#E7E7E9" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-28" points="0.0168196721 0.122168675 44.088332 20.6617771 56.98575 77.9501928 35.3731721 68.2218072"></polygon>
				<linearGradient x1="39.584616%" y1="64.3101353%" x2="65.9216828%" y2="28.1244473%" id="linearGradient-30">
						<stop stop-color="#FBFDFD" offset="0%"></stop>
						<stop stop-color="#E6E6E8" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-31" points="0.17195441 60.1448799 91.2554272 0.0359536878 185.203391 11.4927256 237.837245 136.906708"></polygon>
				<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-33">
						<stop stop-color="#FFFFFF" offset="0%"></stop>
						<stop stop-color="#E8E8EA" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-34" points="0.0397048193 11.639866 23.2794759 0.036414 77.8658494 92.669822 44.7440422 118.949544"></polygon>
				<linearGradient x1="9.4034897e-05%" y1="50.0000406%" x2="99.9998206%" y2="50.0000406%" id="linearGradient-36">
						<stop stop-color="#E6E6E8" offset="0%"></stop>
						<stop stop-color="#FBFDFD" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-37" points="214.824112 69.2162937 111.384697 134.869248 0.172805954 0.223033217"></polygon>
				<linearGradient x1="50.0000236%" y1="100.000051%" x2="50.0000236%" y2="-8.42943308e-05%" id="linearGradient-39">
						<stop stop-color="#FFFFFF" offset="0%"></stop>
						<stop stop-color="#EFF0F0" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-40" points="13.3025671 57.0558496 0.173359756 0.220263158 77.9971463 92.9752932"></polygon>
				<linearGradient x1="33.5132292%" y1="69.2597638%" x2="53.8016116%" y2="45.559028%" id="linearGradient-42">
						<stop stop-color="#EBEBED" offset="0%"></stop>
						<stop stop-color="#DDDDDF" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-43" points="4.02281352 70.0712489 58.7231422 161.851205 100.967275 86.9923493 0.231664336 0.19949345"></polygon>
				<linearGradient x1="31.9403875%" y1="65.9395216%" x2="54.4887871%" y2="29.697935%" id="linearGradient-45">
						<stop stop-color="#FFFFFF" offset="0%"></stop>
						<stop stop-color="#EFF0F0" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-46" points="71.7215361 0.0278158379 0.231664336 169.216 100.967275 255.979256"></polygon>
				<polygon id="path-48" points="99.9146226 0.0276689655 0.0856132075 155.376717 32.0959906 237.801628 28.2981132 168.32251 99.9148585 0.0276689655"></polygon>
				<linearGradient x1="39.2749405%" y1="82.0892304%" x2="66.3772619%" y2="17.9107007%" id="linearGradient-50">
						<stop stop-color="#E6E6E8" offset="0%"></stop>
						<stop stop-color="#FBFDFD" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-51" points="51.9691324 0.116075758 43.937863 39.6535202 9.56158904 46.9164444 0.210849315 33.1008182"></polygon>
				<linearGradient x1="49.999985%" y1="99.999804%" x2="49.999985%" y2="-0.000147850212%" id="linearGradient-53">
						<stop stop-color="#F6E275" offset="0%"></stop>
						<stop stop-color="#E2BA5B" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-54" points="14.3697692 7.19115084 0.216461538 64.7625922 14.3697692 83.9068492 47.7798462 0.0119664804"></polygon>
				<linearGradient x1="30.746395%" y1="77.1392283%" x2="69.9149242%" y2="6.89375545%" id="linearGradient-56">
						<stop stop-color="#F6E275" offset="0%"></stop>
						<stop stop-color="#E2BA5B" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-57" points="0.082962963 23.5227273 63.8267259 18.818643 49.2887704 0.00276737968"></polygon>
				<linearGradient x1="0.000240592892%" y1="50.0001464%" x2="99.9999819%" y2="50.0001464%" id="linearGradient-59">
						<stop stop-color="#F6E275" offset="0%"></stop>
						<stop stop-color="#E2BA5B" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-60" points="0.0623292683 18.818643 37.872561 23.5227273 7.02721951 0.00276737968"></polygon>
				<linearGradient x1="-4.84737806e-05%" y1="50.0001464%" x2="99.9995213%" y2="50.0001464%" id="linearGradient-62">
						<stop stop-color="#E2BA5B" offset="0%"></stop>
						<stop stop-color="#F6E275" offset="100%"></stop>
				</linearGradient>
				<polygon id="path-63" points="14.825597 0.0497120419 10.8105224 44.8148168 0.0371641791 13.9042932"></polygon>
				<linearGradient x1="-0.000923472864%" y1="50.0003341%" x2="99.9995275%" y2="50.0003341%" id="linearGradient-65">
						<stop stop-color="#FFFFFF" offset="0%"></stop>
						<stop stop-color="#EFF0F0" offset="100%"></stop>
				</linearGradient>
			</defs>
					<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<g id="Ryoma_desktop_2_1A" transform="translate(-249.000000, -1074.000000)">
									<g id="Gallo" transform="translate(249.000000, 1074.000000)">
											<g id="Group-3" transform="translate(0.000000, 71.000000)">
													<mask id="mask-2" fill="white">
															<use xlink:href="#path-1"></use>
													</mask>
													<g id="Clip-2"></g>
													<polygon id="Fill-1" fill="url(#linearGradient-3)" mask="url(#mask-2)" points="0 12.6379015 56.832062 30.8154091 45.4975413 0.00375757576"></polygon>
											</g>
											<g id="Group-6" transform="translate(25.000000, 92.000000)">
													<mask id="mask-5" fill="white">
															<use xlink:href="#path-4"></use>
													</mask>
													<g id="Clip-5"></g>
													<polygon id="Fill-4" fill="url(#linearGradient-6)" mask="url(#mask-5)" points="32.8295 10.3089637 28.8489348 44.7701036 0.216173913 0.108419689"></polygon>
											</g>
											<g id="Group-9" transform="translate(45.000000, 40.000000)">
													<mask id="mask-8" fill="white">
															<use xlink:href="#path-7"></use>
													</mask>
													<g id="Clip-8"></g>
													<polygon id="Fill-7" fill="url(#linearGradient-9)" mask="url(#mask-8)" points="0.0409315068 30.767145 17.9787945 0.0719389313 16.3284658 16.851458"></polygon>
											</g>
											<g id="Group-12" transform="translate(53.000000, 58.000000)">
													<mask id="mask-11" fill="white">
															<use xlink:href="#path-10"></use>
													</mask>
													<g id="Clip-11"></g>
													<polygon id="Fill-10" fill="url(#linearGradient-12)" mask="url(#mask-11)" points="8.25755502 0.0495604651 54.4258708 32.406907 97.9971866 100.801288 0.150282297 79.393986 4.05293301 44.6781721"></polygon>
											</g>
											<g id="Group-15" transform="translate(63.000000, 16.000000)">
													<mask id="mask-14" fill="white">
															<use xlink:href="#path-13"></use>
													</mask>
													<g id="Clip-14"></g>
													<polygon id="Fill-13" fill="url(#linearGradient-15)" mask="url(#mask-14)" points="1.58790431 24.1822452 47.9970144 0.222716129 45.2768612 73.9928387 0.0507559809 41.1084323"></polygon>
											</g>
											<g id="Group-18" transform="translate(107.000000, 34.000000)">
													<mask id="mask-17" fill="white">
															<use xlink:href="#path-16"></use>
													</mask>
													<g id="Clip-17"></g>
													<polygon id="Fill-16" fill="url(#linearGradient-18)" mask="url(#mask-17)" points="1.50228824 18.7843682 40.7609941 0.185573222 0.0344882353 55.9929707"></polygon>
											</g>
											<g id="Group-21" transform="translate(108.000000, 73.000000)">
													<mask id="mask-20" fill="white">
															<use xlink:href="#path-19"></use>
													</mask>
													<g id="Clip-20"></g>
													<polygon id="Fill-19" fill="url(#linearGradient-21)" mask="url(#mask-20)" points="0.0339625 18.2853659 12.5112625 0.212195122 56.876025 0.247804878 31.23125 25.727561 7.3043125 29.9836585"></polygon>
											</g>
											<g id="Group-24" transform="translate(53.000000, 137.000000)">
													<mask id="mask-23" fill="white">
															<use xlink:href="#path-22"></use>
													</mask>
													<g id="Clip-23"></g>
													<polygon id="Fill-22" fill="url(#linearGradient-24)" mask="url(#mask-23)" points="0.153194969 0.00333796296 113.970604 102.798053 99.8965031 21.7334769"></polygon>
											</g>
											<g id="Group-27" transform="translate(30.000000, 137.000000)">
													<mask id="mask-26" fill="white">
															<use xlink:href="#path-25"></use>
													</mask>
													<g id="Clip-26"></g>
													<polygon id="Fill-25" fill="url(#linearGradient-27)" mask="url(#mask-26)" points="23.1591913 0.00330131004 0.0169043478 141.371528 44.310287 161.987031 134.971122 101.669266"></polygon>
											</g>
											<g id="Group-30" transform="translate(30.000000, 279.000000)">
													<mask id="mask-29" fill="white">
															<use xlink:href="#path-28"></use>
													</mask>
													<g id="Clip-29"></g>
													<polygon id="Fill-28" fill="url(#linearGradient-30)" mask="url(#mask-29)" points="0.0168196721 0.122168675 44.088332 20.6617771 56.98575 77.9501928 35.3731721 68.2218072"></polygon>
											</g>
											<g id="Group-33" transform="translate(75.000000, 240.000000)">
													<mask id="mask-32" fill="white">
															<use xlink:href="#path-31"></use>
													</mask>
													<g id="Clip-32"></g>
													<polygon id="Fill-31" fill="url(#linearGradient-33)" mask="url(#mask-32)" points="0.17195441 60.1448799 91.2554272 0.0359536878 185.203391 11.4927256 237.837245 136.906708"></polygon>
											</g>
											<g id="Group-36" transform="translate(260.000000, 238.000000)">
													<mask id="mask-35" fill="white">
															<use xlink:href="#path-34"></use>
													</mask>
													<g id="Clip-35"></g>
													<polygon id="Fill-34" fill="url(#linearGradient-36)" mask="url(#mask-35)" points="0.0397048193 11.639866 23.2794759 0.036414 77.8658494 92.669822 44.7440422 118.949544"></polygon>
											</g>
											<g id="Group-39" transform="translate(73.000000, 300.000000)">
													<mask id="mask-38" fill="white">
															<use xlink:href="#path-37"></use>
													</mask>
													<g id="Clip-38"></g>
													<polygon id="Fill-37" fill="url(#linearGradient-39)" mask="url(#mask-38)" points="214.824112 69.2162937 111.384697 134.869248 0.172805954 0.223033217"></polygon>
											</g>
											<g id="Group-42" transform="translate(74.000000, 300.000000)">
													<mask id="mask-41" fill="white">
															<use xlink:href="#path-40"></use>
													</mask>
													<g id="Clip-41"></g>
													<polygon id="Fill-40" fill="url(#linearGradient-42)" mask="url(#mask-41)" points="13.3025671 57.0558496 0.173359756 0.220263158 77.9971463 92.9752932"></polygon>
											</g>
											<g id="Group-45" transform="translate(279.000000, 170.000000)">
													<mask id="mask-44" fill="white">
															<use xlink:href="#path-43"></use>
													</mask>
													<g id="Clip-44"></g>
													<polygon id="Fill-43" fill="url(#linearGradient-45)" mask="url(#mask-44)" points="4.02281352 70.0712489 58.7231422 161.851205 100.967275 86.9923493 0.231664336 0.19949345"></polygon>
											</g>
											<g id="Group-48" transform="translate(279.000000, 0.000000)">
													<mask id="mask-47" fill="white">
															<use xlink:href="#path-46"></use>
													</mask>
													<g id="Clip-47"></g>
													<polygon id="Fill-46" mask="url(#mask-47)" points="71.7215361 0.0278158379 0.231664336 169.216 100.967275 255.979256"></polygon>
											</g>
											<g id="Group-51" transform="translate(250.000000, 0.000000)">
													<mask id="mask-49" fill="white">
															<use xlink:href="#path-48"></use>
													</mask>
													<g id="Clip-50"></g>
													<polygon id="Fill-49" fill="url(#linearGradient-50)" mask="url(#mask-49)" points="99.9146226 0.0276689655 0.0856132075 155.376717 32.0959906 237.801628 28.2981132 168.32251 99.9148585 0.0276689655"></polygon>
											</g>
											<g id="Group-54" transform="translate(185.000000, 401.000000)">
													<mask id="mask-52" fill="white">
															<use xlink:href="#path-51"></use>
													</mask>
													<g id="Clip-53"></g>
													<polygon id="Fill-52" fill="url(#linearGradient-53)" mask="url(#mask-52)" points="51.9691324 0.116075758 43.937863 39.6535202 9.56158904 46.9164444 0.210849315 33.1008182"></polygon>
											</g>
											<g id="Group-57" transform="translate(180.000000, 441.000000)">
													<mask id="mask-55" fill="white">
															<use xlink:href="#path-54"></use>
													</mask>
													<g id="Clip-56"></g>
													<polygon id="Fill-55" fill="url(#linearGradient-56)" mask="url(#mask-55)" points="14.3697692 7.19115084 0.216461538 64.7625922 14.3697692 83.9068492 47.7798462 0.0119664804"></polygon>
											</g>
											<g id="Group-60" transform="translate(131.000000, 506.000000)">
												<mask id="mask-58" fill="white">
														<use xlink:href="#path-57"></use>
												</mask>
												<g id="Clip-59"></g>
												<polygon id="Fill-58" fill="url(#linearGradient-59)" mask="url(#mask-58)" points="0.082962963 23.5227273 63.8267259 18.818643 49.2887704 0.00276737968"></polygon>
											</g>
											<g id="Group-63" transform="translate(195.000000, 506.000000)">
												<mask id="mask-61" fill="white">
													<use xlink:href="#path-60"></use>
												</mask>
												<g id="Clip-62"></g>
												<polygon id="Fill-61" fill="url(#linearGradient-62)" mask="url(#mask-61)" points="0.0623292683 18.818643 37.872561 23.5227273 7.02721951 0.00276737968"></polygon>
											</g>
											<g id="Group-66" transform="translate(45.000000, 58.000000)">
												<mask id="mask-64" fill="white">
														<use xlink:href="#path-63"></use>
												</mask>
												<g id="Clip-65"></g>
												<polygon id="Fill-64" fill="url(#linearGradient-65)" mask="url(#mask-64)" points="14.825597 0.0497120419 10.8105224 44.8148168 0.0371641791 13.9042932"></polygon>
											</g>
									</g>
							</g>
					</g>
		</svg>
		
<svg
	v-else-if="animal === 'penguin'"
	class="svg-penguin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 319 558">
	
<!-- <g id="save">
	<path d="M219.6,26.9h-25.8v31h31V31.9L219.6,26.9z M213.5,30.3v8.6h-3.4v-8.6H213.5z M221.4,54.5h-24.2V30.3h4.3v12h15.4v-12h1.4
		l3.2,3.1V54.5z"/>
</g> -->
<!-- <g id="RSS">
	<path fill="#ffffff" id="circle_2_" class="st0" d="M73.4,52c4.9,0,8.5,3.9,8.5,8.5c0,4.9-3.9,8.5-8.5,8.5s-8.5-3.9-8.5-8.5
		C64.9,55.6,68.5,52,73.4,52z"/>
	<path fill="#ffffff" class="st0" d="M81.5,26.9v11.4c-8.2,0-15.7,3.3-21.2,9.1c-5.6,5.6-8.8,13.1-9.1,21.2H39.7C40.1,45.8,58.7,27.2,81.5,26.9
		L81.5,26.9z"/>
	<path fill="#ffffff" class="st0" d="M81.5,5v11.1c-28.7,0.3-52.3,23.5-52.3,52.3H17.8C18.2,33.7,46.6,5.3,81.5,5L81.5,5z"/>
</g> -->
<g id="Page-1">
	<g id="Ryoma_desktop_v1_3" transform="translate(-217.000000, -97.000000)">
		<g id="Group" transform="translate(217.000000, 97.000000)">
			<g id="Penguin" transform="translate(0.000000, -0.000000)">
				<polyline id="Fill-2436" class="st1" points="66.3,500.2 0,557.4 108.2,557.4 66.3,500.2 				"/>
				<polyline id="Fill-2437" class="st2" points="66.3,500.2 39.8,523.1 108.2,557.4 66.3,500.2 				"/>
				<polyline id="Fill-2441" class="st3" points="100.4,155.6 39.8,173.2 145.3,227.8 174.6,188.8 100.4,155.6 				"/>
				<polyline id="Fill-2442" class="st4" points="162.9,181 33.9,317.5 43.7,502.8 107.2,556.6 108.2,557.4 225.4,557.4 
					318.2,295.1 162.9,181 				"/>
				<polyline id="Fill-2443" class="st5" points="205.9,389.7 225.4,557.4 318.2,295.1 205.9,389.7 				"/>
				<polyline id="Fill-2446" class="st6" points="183.4,388.7 190.3,470.6 318.2,295.1 183.4,388.7 				"/>
				<polyline id="Fill-2447" class="st7" points="318.2,295.1 166.8,463.8 194.2,208.3 318.2,295.1 				"/>
				<polyline id="Fill-2448" class="st8" points="125.8,114.7 243,110.8 318.2,295.1 125.8,114.7 				"/>
				<polyline id="Fill-2449" class="st9" points="125.8,114.7 100.4,155.6 318.2,295.1 125.8,114.7 				"/>
				<g id="Image-3499">
					
						<image style="overflow:visible;enable-background:new    ;" width="43" height="11" xlink:href="B2B36A1F3F2F4DFB.png"  transform="matrix(3.1737 0 0 3.1737 123.4646 109.0287)">
					</image>
					<g>
						<rect id="rect-1" x="123.5" y="109" class="st10" width="136.5" height="35"/>
					</g>
				</g>
				<g id="Image-3500">
					
						<image style="overflow:visible;enable-background:new    ;" width="15" height="10" xlink:href="B2B36A1F3F2F4DF9.png"  transform="matrix(3.1934 0 0 3.1934 107.5304 112.0341)">
					</image>
					<g>
						<rect id="rect-2" x="107.5" y="112" class="st11" width="47.9" height="31.9"/>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
<use xlink:href="#Save"  width="64" height="64" x="-32" y="-32" transform="matrix(0.4843 0 0 -0.4843 209.3114 42.3707)" style="overflow:visible;"/>
</svg>
		<svg 
			v-else-if="animal === 'iceberg'"
			class="svg-iceberg"
			viewBox="0 0 497 699">
			<g id="Layer_2">
				<polygon class="st0" points="490,103 411,0 460,0 	"/>
				<polygon class="st1" points="266,139 490,103 411,0 325,0 	"/>
				<polygon class="st2" points="266,139 490,103 438,381 	"/>
				<polygon class="st3" points="177,345 438,381 266,139 	"/>
				<polygon class="st4" points="169,0 325,0 266,139 	"/>
				<polygon class="st5" points="111,0 193.94,35.74 169,0 	"/>
				<polygon class="st6" points="42,51.5 193.94,35.74 111,0 54,0 	"/>
				<polygon class="st7" points="106,191 193.94,35.74 266,139 	"/>
				<polygon class="st8" points="42,51.5 193.94,35.74 106,191 	"/>
				<polygon class="st9" points="5,85 42,51.5 74.25,121.8 	"/>
				<polygon class="st10" points="21,310 74.25,121.8 111,450 	"/>
				<polygon class="st11" points="369,693 177,345 106.09,190.96 74.25,121.8 111,450 	"/>
				<polygon class="st12" points="177,345 438,381 369,693 	"/>
				<polygon class="st13" points="5,85 21,310 74.25,121.8 	"/>
				<polygon class="st14" points="266,139 177,345 106.09,190.96 	"/>
			</g>
		</svg>

		<svg 
			v-else-if="animal === 'banner'"
			viewBox="0 0 640 480"
			class="svg-banner">
			<polygon 
				class="st0" 
				points="300,295 473,223 368,67 "/>
			<polygon 
				class="st1" 
				points="346,310 473,223 300,295 "/>
			<polygon 
				class="st2" points="337,434 640,240 346,310 "/>
			<polygon 
				class="st3" points="300,295 346,310 337,434 "/>
			<polygon 
				class="st4" points="151,272 300,295 337,434 "/>
			<polygon 
				class="st5" points="6,212 227,229 151,272 "/>
			<polygon 
				class="st6" points="300,295 227,229 151,272 "/>
			<polygon 
				class="st7" points="94,44 267.68,163.85 121,190 "/>
			<polygon 
				class="st8" points="368,67 94,44 267.68,163.85 "/>
			<polygon 
				class="st9" points="227,229 368,67 267.68,163.85 "/>
			<polygon 
				class="st10" points="6,212 121,190 227,229 "/>
			<polygon 
				class="st11" points="267.68,163.85 121,190 227,229 "/>
			<polygon 
				class="st12" points="368,67 300,295 227,229 "/>
		</svg>
		
		<svg
			v-else-if="animal === 'lion'"
			class="svg-lion" 
			viewBox="0 0 420.3 426.9">
			
			<polygon class="st0" points="163.8,355.6 330.6,174.4 164.8,154.2 0,174.4 "/>
			<polygon class="st1" points="342.1,342.5 351.8,384.7 361.4,426.9 271.3,426.9 256.3,281.8 "/>
			<polygon class="st2" points="116.6,71.3 118.5,174.4 212,174.4 211.1,71.3 "/>
			<polygon class="st3" points="118.5,174.4 212,174.4 163.8,123.4 "/>
			<polygon class="st4" points="212,148.9 280.5,33.7 211.1,71.3 "/>
			<polygon class="st4" points="116.6,71.3 47.2,33.7 118.1,148.9 "/>
			<polygon class="st5" points="232.3,33.7 258.3,0 280.5,33.7 "/>
			<polygon class="st6" points="69.4,0 47.2,33.7 95.4,33.7 "/>
			<polygon class="st7" points="330.6,174.4 212,160.9 212,148.9 274.5,43.7 "/>
			<polygon class="st8" points="53.3,43.7 0,174.4 118.5,162.4 118.1,148.9 "/>
			<polygon class="st9" points="135.9,426.9 125,312.7 75.5,258 64.6,342.5 "/>
			<polygon class="st10" points="53,426.9 64.6,342.5 135.9,426.9 "/>
			<polygon class="st11" points="163.8,426.9 163.8,355.6 125,312.7 135.9,426.9 "/>
			<polygon class="st11" points="193.7,426.9 203.3,312.7 163.8,355.6 163.8,426.9 "/>
			<polygon class="st12" points="263.1,342.5 193.7,426.9 276.6,426.9 "/>
			<polygon class="st13" points="253.7,258 203.3,312.7 193.7,426.9 263.1,342.5 256.3,281.8 "/>
			<polygon class="st14" points="404.8,408.6 414.4,426.9 361.4,426.9 351.8,384.7 "/>
			<polygon class="st15" points="135.9,110.8 193.7,110.8 164.8,154.2 "/>
			<polygon class="st16" points="47.2,33.7 280.5,33.7 211.1,71.3 116.6,71.3 "/>
		</svg>

	</figure>
</template>

<script>
import BirdVector from './groups/BirdVector'

export default {
    name: 'services-origami',
    props: ['animal', 'fill', 'type'],
    components: {
        BirdVector
    }
}
</script>

<style lang="scss" scoped>
@import '../../styles/_mixins.scss';

svg {
	display: block;
	max-width: 80vw;
	margin: 0 auto;
	position: relative;
	z-index: $z_index;

	.service-cover & {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 100%;
		transform: translate(-50%,-50%);
	}

	&.svg-penguin {
		top: auto;
		bottom: 0;
		transform: translate(-50%,0);
		width: 45%;


	.st0{fill:#6A6A6A;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#C4C4C4;}
	.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#A5A5A5;}
	.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#4A4A4A;}
	.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#E7E7E7;}
	.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#424242;}
	.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#3F3F3F;}
	.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#545757;}
	.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#535353;}
	.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#6A6A6A;}
	.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#4E4D4D;}
	.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#787676;}
	}

	&.svg-iceberg {
		top: 0;
		transform: translate(-50%,0);
		width: 55%;
		.st0{fill:#9CD3EE;}
		.st1{fill:#BEE0F2;}
		.st2{fill:#6DACDA;}
		.st3{fill:#83BEE2;}
		.st4{fill:#D0E7F4;}
		.st5{fill:#97CCED;}
		.st6{fill:#D3E8F4;}
		.st7{fill:#A0D4EB;}
		.st8{fill:#C6E3F3;}
		.st9{fill:#CAE3F2;}
		.st10{fill:#84C4E5;}
		.st11{fill:#63A4D5;}
		.st12{fill:#62A3D3;}
		.st13{fill:#A0D3EA;}
		.st14{fill:#8CC8E9;}
	}

	&.svg-banner {
		.st0{fill:#A6DACB;}
		.st1{fill:#1E5745;}
		.st2{fill:#F4FAF4;}
		.st3{fill:#EAEED2;}
		.st4{fill:#59B5AE;}
		.st5{fill:#C35036;}
		.st6{fill:#CF7752;}
		.st7{fill:#1F4450;}
		.st8{fill:#031725;}
		.st9{fill:#244A56;}
		.st10{fill:#D72B26;}
		.st11{fill:#497788;}
		.st12{fill:#588E7E;}
	}

	&.svg-lion {
		top: auto;
		bottom: 0;
		transform: translate(-50%,0);
		width: 65%;
		.st0{fill:#5F3022;}
		.st1{fill:#EE963D;}
		.st2{fill:#F5BB44;}
		.st3{fill:#C67335;}
		.st4{fill:#933B1E;}
		.st5{fill:#C84C2B;}
		.st6{fill:#CA512C;}
		.st7{fill:#D85530;}
		.st8{fill:#A94324;}
		.st9{fill:#E78E3C;}
		.st10{fill:#D34D2E;}
		.st11{fill:#4F261B;}
		.st12{fill:#DB5C31;}
		.st13{fill:#EE8742;}
		.st14{fill:#924027;}
		.st15{fill:#A44626;}
		.st16{fill:#F19A3E;}
	}
}
</style>